import {
  XDamage,
  XImpactSize,
  XOperationType,
  XStatus,
  XWindows,
} from './const';

export interface SlotsDamagedGlassV1 {
  window?: [
    {
      window: XWindows;
    }
  ];
  type: XDamage;
  impacts?: {
    size?: XImpactSize;
    /** true si impact dans le champ de vision, sinon false */
    isInViewField?: boolean;
    /** true si impact à moins de 4cm du bord, sinon false*/
    isInEdge?: boolean;
  }[];
}

export interface FreeSlotsWsV1ParamsBase {
  recommendedOperationType: XOperationType;
  /** 1 pour prêt de véhicule, 0 sans */
  share?: 1 | 0;
  damage: SlotsDamagedGlassV1;
}

export interface MobileServicesV1Param {
  mobileServices: {
    /** Si Pose à Dom demandée */
    postalCode: string;
    city: string;
  };
}

export interface PartnerBranchV1Param {
  partnerBranch: {
    /** N° FCE AXA unique du centre */
    id: string;
  };
}

export type GetFreeSlotsV1Params = PartnerBranchV1Param | MobileServicesV1Param;

export interface FreeSlotsWsV1ParamsPB
  extends FreeSlotsWsV1ParamsBase,
    PartnerBranchV1Param {}

export interface FreeSlotsWsV1ParamsMS
  extends FreeSlotsWsV1ParamsBase,
    MobileServicesV1Param {}

export type FreeSlotsWsV1Params = FreeSlotsWsV1ParamsMS | FreeSlotsWsV1ParamsPB;

export interface FreeSlotsWsV1ResponseSuccess {
  /** Durée d'intervention en minutes */
  interventionDuration: string;
  /** immobilisationDuration */
  immobilisationDuration: string;
  /** true si intervention difficile, sinon false */
  isInterventionDifficult?: boolean | string;
  partnerBranch: {
    /** N° FCE AXA unique du centre */
    id: string;
    name: string;
    address: string;
    postalCode: string;
    city: string;
  };
  days: {
    /** YYYYMMDD */
    day: string;
    status: XStatus;
    /** Obligatoire si status status == 'O' */
    openingTime?: Date;
    /** Obligatoire si status status == 'O' */
    closingTime?: Date;
    availableSlots: { id: string; start: string | Date }[];
  }[];
}

export interface FreeSlotWsV1ResponseError {
  status: 'ERROR';
  response: {
    code: string;
    message: string;
  };
}
